import { Injectable } from '@angular/core';
import { Group, GroupsService } from '@era/security-sdk';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap } from 'rxjs/operators';
import { MemberGroupResolverActions, MemberGroupApiActions, MemberGroupListActions } from './member-group.actions';
import { safeMap } from '../effects.helpers';

@Injectable()
export class GroupEffects {
  constructor(
    private readonly groupService: GroupsService,
    private readonly actions$: Actions
  ) {}

  groupMemberLoadedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MemberGroupResolverActions.memberGroupsRequested),
      mergeMap(({ group }) =>
        safeMap(
          this.groupService.getNestedGroups(group.id),
          (groups: Group[]) => MemberGroupApiActions.memberGroupsLoaded({ groups }),
          (error) => MemberGroupApiActions.memberGroupsLoadedError({ error })
        )
      )
    );
  });

  groupMemberDeletedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MemberGroupApiActions.memberGroupsGroupDeleted),
      mergeMap(({ group }) =>
        safeMap(
          this.groupService.removeGroupFromGroup(group.parentId, group.id),
          () => MemberGroupListActions.memberGroupsDeleted({ group }),
          (error) => MemberGroupApiActions.memberGroupsDeletedError({ error })
        )
      )
    );
  });

  groupMemberAddedEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MemberGroupApiActions.memberGroupsAdded),
      mergeMap(({ group, groupToAdd }) =>
        safeMap(
          this.groupService.addGroupToGroup(group.id, { id: groupToAdd.id }),
          () => MemberGroupListActions.memberGroupsAdded({ group, groupToAdd }),
          (error) => MemberGroupApiActions.memberGroupsAddedError({ error })
        )
      )
    );
  });
}
